import { BannerBg } from 'assets';
import Image from 'next/image';
import React, { FC } from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { twMerge } from 'tailwind-merge';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

interface Props {
  className?: string;
}

const Banner: FC<Props> = ({ className }) => {
  return (
    <div
      onClick={() => {
        if (typeof window !== 'undefined') {
          const url = 'https://go.zebralearn.com/inquiry-form';
          window.open(url, '_blank');
        }
      }}
      className={twMerge(
        `relative md:h-[150px] h-[90px] w-full bg-black rounded-lg overflow-hidden flex justify-center items-center md:px-11 px-5`,
        className,
      )}
    >
      <Image
        className='h-full absolute top-0 left-0 z-[1]'
        alt='Explore Bulk Purchases for Your Company or College'
        src={BannerBg}
        width={1279}
        height={150}
      />
      <div className='relative z-[2] flex items-center md:gap-[68px] gap-5 flex-1 h-full justify-center max-w-5xl'>
        <p className='line-clamp-3 md:text-2xl text-sm font-semibold text-white flex-1'>
          Explore Bulk Purchases for Your{' '}
          <span className='text-primary'>Company or College</span>
        </p>
        <ButtonDefault
          className='md:py-2.5 py-1.5  md:px-5 px-2.5 flex items-center justify-center '
          size={0}
          variant={ButtonVariants.PRIMARY}
          is3D
        >
          <div className='flex md:gap-2 gap-1 items-center flex-1'>
            <p className='md:text-sm text-[10px] text-white font-semibold text-nowrap '>
              Contact Us
            </p>
            <BiChevronRight className='md:w-[22px] w-3.5  md:h-[22px] h-3.5' />
          </div>
        </ButtonDefault>
      </div>
    </div>
  );
};

export default Banner;
